import { useQuery } from '@tanstack/react-query';
import useApi from 'vl-common/src/hooks/useApi';

export default function useFetchEmployerPatientMeta(clientId: string) {
  const { Api } = useApi();
  const { data: employers = [] } = useQuery({
    queryKey: ['employerPatientMeta', clientId],
    queryFn: () => {
      return Api.admin.employer.getAll({ client_id: clientId }).then((res) => {
        const { data } = res;
        return data.employers?.filter((employer: any) => employer.available_to_patients);
      });
    },
    enabled: !!clientId
  });

  return employers;
}
